export default "__VITE_ASSET__CROV1UhY__"